export const navigationLinks = [
  { name: 'Projects', href: '/#development-work' },
  { name: 'Design Work', href: '/#design-work' },
  { name: 'Contact', href: '/contact' },
];